import { render, staticRenderFns } from "./add-device.vue?vue&type=template&id=3236288c&scoped=true"
import script from "./add-device.ts?vue&type=script&lang=ts&external"
export * from "./add-device.ts?vue&type=script&lang=ts&external"
import style0 from "./add-device.scoped.scss?vue&type=style&index=0&id=3236288c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3236288c",
  null
  
)

export default component.exports